import { render, staticRenderFns } from "./PurchasesDeliveryListTable.vue?vue&type=template&id=54218cde"
import script from "./PurchasesDeliveryListTable.vue?vue&type=script&lang=js"
export * from "./PurchasesDeliveryListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports